<template>
  <v-card
    :elevation="elevation"
    :outlined="outlined"
    :class="classes"
  >
    <slot />
  </v-card>
</template>

<script>

export default {
  name: 'Card',
  props: {
    elevation: {
      type: [Number, String],
      default: 0,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    classes() {
      if (this.white) return ['white-card']
      
      const list = ['card']
      if (this.error) {
        list.push('form-error')
      }
      return list
    },
  },
}
</script>

<style scoped>
.card {
  padding: 4px;
  border: 1px solid #e3e3e3;
  background-color: rgba(0,0,0,0)
}

.white-card {
  padding: 4px;
  background-color: white;
  border-radius: 10px
}

.card.form-error {
  border-color: red;
}
</style>
